import { render, staticRenderFns } from "./CuTabSelect.vue?vue&type=template&id=04bca6be&scoped=true"
import script from "./CuTabSelect.vue?vue&type=script&lang=js"
export * from "./CuTabSelect.vue?vue&type=script&lang=js"
import style0 from "./CuTabSelect.vue?vue&type=style&index=0&id=04bca6be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bca6be",
  null
  
)

export default component.exports